import React, { Component } from 'react';
import './GeneralModal.css';

/**
 * An general use local state modal.
 * @constructor
 * @prop {bool} open - The modal state as defined by parent.
 */

class GeneralModal extends Component {
  constructor(props){
    super(props);
    this.state = {};
  }
  getModal(){
    let { open, toggleModal } = this.props;
    if(open){
      return (
        <div className='general-modal'>
          <div className='general-modal__mask' onClick={toggleModal}>
            <div className='general-modal__content'>
            <div className="closeModal-container">
              <div onClick={toggleModal} className='general-modal__close-modal'>
                <svg viewBox="0 0 74.9 74.9" onClick={toggleModal}>
                  <rect x="6.1" y="41.1" width="87.9" height="18.05" transform="translate(37.5 -33.4) rotate(45)"/>
                  <rect x="6.1" y="41.1" width="87.9" height="18.05" transform="translate(108.3 37.5) rotate(135)"/>
                </svg>
              </div>
              { this.props.children }
            </div>
            </div>
          </div>
        </div>
      );
    }
  }
  render(){
    return (
      <div>
        {this.getModal()}
      </div>
    );
  }
}

export default GeneralModal;
